import Api from "./Api";
import { API_VERSION } from "@/config/index";
export default {
  GetOffers(payload) {
    return Api().get(`${API_VERSION}/webapp/offers`, payload);
  },
  GetOfferData(payload) {
    const { offer_id } = payload;
    return Api().get(`${API_VERSION}/webapp/offer/${offer_id}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiServices/OfferService.js